module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"books_settings":"Books Settings","import_data":"Import data","import_existing_data_from":"Import existing data from your previous accounting system into Books"},"id":{}}')
  delete Component.options._Ctor
}
